import { ENVS } from "config";
import type { SessionUser } from "types/session-user";
import { SignupMethod } from "store/types/profile";

type SessionLike = Pick<
  SessionUser,
  | "pricing_plan_id"
  | "subscription"
  | "is_active"
  | "signup_method"
  | "oauth2_sso_config_id"
  | "first_name"
  | "last_name"
  | "email"
> | null;

export const selectIsOnExpiredFreeTrial = (profile: SessionLike): boolean => {
  if (!profile) return false;
  return (
    profile.pricing_plan_id === Number(ENVS.freePlanId) &&
    profile.subscription?.status === "trialing" &&
    new Date(profile.subscription.end_date) <= new Date()
  );
};

export const selectIsOnActivePastDueSubscription = (profile: SessionLike): boolean => {
  if (!profile) return false;
  return profile.is_active && profile.subscription?.status === "past_due";
};

export const selectIsEnterpriseUser = (profile: SessionLike): boolean => {
  if (!profile) return false;
  return profile.signup_method === SignupMethod.SSO && profile.oauth2_sso_config_id !== null;
};

export const selectIsProfileActive = (profile: SessionLike): boolean => {
  return Boolean(profile?.is_active);
};

export const selectProfileInitials = (
  profile: Pick<SessionUser, "first_name" | "last_name" | "email"> | null
) => {
  const first_name = profile?.first_name ?? "";
  const last_name = profile?.last_name ?? "";
  const email = (profile?.email ?? "").trim();
  const f = (first_name || "").trim();
  const l = (last_name || "").trim();
  const fi = f ? f[0] : "";
  const li = l ? l[0] : "";
  const fromNames = `${fi}${li}`;
  if (fromNames) return fromNames.toUpperCase();

  const fromEmail = email[0];
  if (fromEmail) return fromEmail.toUpperCase();

  return "?";
};
